import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/core/_config/app.config';
import { ApiServiceExtension } from 'src/app/core/extension/apiServiceExtension';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LevelModel } from 'src/app/models/afs/level.model';
import { CustomResponse } from 'src/app/interfaces/CustomResponse';
import { Period } from 'src/app/views/pages/billet/models/period.model';

@Injectable({
   providedIn: 'root',
})
export class PeriodService extends ApiServiceExtension {
   constructor(protected config: AppConfig, public http: HttpClient) {
      super(config, http);
   }

   public getByEntityIdAndSubAccount(entityId: string, subAccount: string): Observable<CustomResponse<Period>> {
      let url = `${this.API_URL}Period/GetByEntityIdAndSubAccount`;
      return this.http.get<CustomResponse<LevelModel>>(url, {
         params: {
            entityId: entityId,
            subAccount: subAccount,
         },
      });
   }
}
